import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import type { GfWorkDetail } from '@/features/gfWorks/types';
import utilsStyles from '@/styles/modules/utils.module.scss';
import WorksDetailThumbnail from '../WorksDetailThumbnail/WorksDetailThumbnail';
import styles from './WorksDetailFooterProductFirst.module.scss';

function WorksDetailFooterProductFirst({ work }: { work: GfWorkDetail }) {
  return (
    <>
      <div className={utilsStyles.gfMtMedium}>
        <PageHeader text='作品情報' textBold size='xSmall' />
      </div>
      <div className={styles.worksDetailThumbnailContainer}>
        <WorksDetailThumbnail work={work} />
      </div>
    </>
  );
}

export default WorksDetailFooterProductFirst;
